/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cloneDeep from 'lodash/cloneDeep';

// deep clone state
export function cloneState(state) {
    return cloneDeep(state);
}
